import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgAccountModalLegalCopy',
})
export default class CmgAccountModalLegalCopy extends Vue {
  get legalCopy(): string {
    return this.$services.config.getLegalText().loggedInUnEnrolled;
  }
}
